import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Link as RouterLink } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import MoreVert from '@material-ui/icons/MoreVert'
import Popover from 'antd/lib/popover'
import Link from '@material-ui/core/Link'

//*OnTime
export const ColumnsForProcessOnTimeSpa = (
  [
    {
      name: "",
      width: '10px',
      center: true,
      cell: row => (showButtonsProcessInTimeSpa(row))
    },
    {
      name: 'Urgente',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Estatus',
      selector: 'woStatus',
      sortable: true,
      width: '100px',
      cell: row => row.woStatus
    },
    {
      name: 'Marca',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Modelo',
      selector: 'modelCar',
      sortable: true,
      width: '90px',
      cell: row => row.modelCar
    },
    {
      name: 'Placas',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'Ciudad',
      selector: 'procedureStates',
      sortable: true,
      width: '170px',
      cell: row => row.procedureStates
    },
    {
      name: 'Trámites',
      selector: 'procedures',
      sortable: true,
      width: '170px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fecha de asignación',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Flota',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unidad',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Proveedor',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      width: '0%',
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

export const ColumnsForProcessOnTimeEng = (
  [
    {
      name: "",
      width: '10px',
      center: true,
      cell: row => (showButtonsProcessInTimeEng(row))
    },
    {
      name: 'Urgent',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Status',
      selector: 'woStatus',
      sortable: true,
      width: '100px',
      cell: row => row.woStatus
    },
    {
      name: 'Brand',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Model',
      selector: 'modelCar',
      sortable: true,
      width: '90px',
      cell: row => row.modelCar
    },
    {
      name: 'Plates',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'State',
      selector: 'procedureStates',
      sortable: true,
      width: '100px',
      cell: row => row.procedureStates
    },
    {
      name: 'Procedures',
      selector: 'procedures',
      sortable: true,
      width: '100px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Assignment Date',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unit',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Provider',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsProcessInTimeSpa = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOnTime/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )

}

const showButtonsProcessInTimeEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOnTime/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )

}

//*OutOfTime
export const ColumnsForProcessOutOfTimeSpa = (
  [
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsProcessOutOfTimeSpa(row))
    },
    {
      name: 'Urgente',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Estatus',
      width: '125px',
      cell: row => (showTrafficLightsOutOfTimeSpa(row))
    },
    {
      name: 'Marca',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Modelo',
      selector: 'modelCar',
      sortable: true,
      width: '160px',
      cell: row => row.modelCar
    },
    {
      name: 'Placas',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'Ciudad',
      selector: 'procedureStates',
      sortable: true,
      width: '170px',
      cell: row => row.procedureStates
    },
    {
      name: 'Trámites',
      selector: 'procedures',
      sortable: true,
      width: '170px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fecha de asignación',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Flota',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unidad',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Proveedor',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      width: '0%',
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

export const ColumnsForProcessOutOfTimeEng = (
  [
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsProcessOutOfTimeEng(row))
    },
    {
      name: 'Urgent',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Status',
      selector: 'woStatus',
      sortable: true,
      width: '125px',
      cell: row => (showTrafficLightsOutOfTimeEng(row))
    },
    {
      name: 'Brand',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Model',
      selector: 'modelCar',
      sortable: true,
      width: '160px',
      cell: row => row.modelCar
    },
    {
      name: 'Plates',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'State',
      selector: 'procedureStates',
      sortable: true,
      width: '100px',
      cell: row => row.procedureStates
    },
    {
      name: 'Procedures',
      selector: 'procedures',
      sortable: true,
      width: '100px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Assignment Date',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unit',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Provider',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsProcessOutOfTimeSpa = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOutOfTime/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showButtonsProcessOutOfTimeEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOutOfTime/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showTrafficLightsOutOfTimeSpa = (row) => {
  switch (row.orderDays) {
    case '+15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleRed}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              +15 días
            </label>
          </Grid>
        </Grid>
      )
    case '-15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleGreen}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              -15 días
            </label>
          </Grid>
        </Grid>
      )
    default:
      return
  }
}

const showTrafficLightsOutOfTimeEng = (row) => {
  switch (row.orderDays) {
    case '+15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleRed}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              +15 days
            </label>
          </Grid>
        </Grid>
      )
    case '-15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleGreen}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              15 days
            </label>
          </Grid>
        </Grid>
      )
    default:
      return
  }
}

const circleStyleRed = {
  padding: 5,
  display: "inline-block",
  backgroundColor: "#BF2E2E",
  borderRadius: "100%",
  width: 20,
  height: 20,
}
const circleStyleGreen = {
  padding: 5,
  display: "inline-block",
  backgroundColor: "#82C341",
  borderRadius: "100%",
  width: 25,
  height: 25,
}

//*Reception
export const ColumnsForReceptionProcessSpa = (
  [
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsReceptionProcessSpa(row))
    },
    {
      name: 'Urgente',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Estatus',
      selector: 'woStatus',
      sortable: true,
      width: '125px',
      cell: row => (showTrafficLightsReceptionProcessSpa(row))
    },
    {
      name: 'Marca',
      selector: 'make',
      sortable: true,
      width: '120px',
      cell: row => row.make
    },
    {
      name: 'Modelo',
      selector: 'modelCar',
      sortable: true,
      width: '150px',
      cell: row => row.modelCar
    },
    {
      name: 'Placas',
      selector: 'plate',
      sortable: true,
      cell: row => row.plate
    },
    {
      name: 'Ciudad',
      selector: 'procedureStates',
      sortable: true,
      width: '170px',
      cell: row => row.procedureStates
    },
    {
      name: 'Trámites',
      selector: 'procedures',
      sortable: true,
      width: '170px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fecha de asignación',
      selector: 'assignedSupplierDate',
      center: true,
      sortable: true,
      cell: row => row.assignedSupplierDate
    },
    {
      name: 'Fecha de cierre',
      selector: 'endDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Flota',
      selector: 'fleet',
      center: true,
      sortable: true,
      cell: row => row.fleet
    },
    {
      name: 'Unidad',
      selector: 'unitNumber',
      center: true,
      sortable: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Proveedor',
      selector: 'supplierName',
      center: true,
      sortable: true,
      width: '150px',
      cell: row => row.supplierName
    },
  ]
)

export const ColumnsForReceptionProcessEng = (
  [
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsReceptionProcessEng(row))
    },
    {
      name: 'Urgent',
      selector: 'urgentWO',
      sortable: true,
      width: '70px',
      cell: row => (showTrafficLightsWOUrgent(row))
    },
    {
      name: 'ID Xcelerate',
      selector: 'idXcelerate',
      sortable: true,
      width: '100px',
      cell: row => row.idXcelerate === 0 ? '' : row.idXcelerate
    },
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Status',
      selector: 'woStatus',
      sortable: true,
      width: '125px',
      cell: row => (showTrafficLightsReceptionProcessEng(row))
    },
    {
      name: 'Brand',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Model',
      selector: 'modelCar',
      sortable: true,
      width: '150px',
      cell: row => row.modelCar
    },
        {
      name: 'State',
      selector: 'procedureStates',
      sortable: true,
      width: '100px',
      cell: row => row.procedureStates
    },
    {
      name: 'Procedures',
      selector: 'procedures',
      sortable: true,
      width: '100px',
      cell: row => {
        const text = row.procedures || "";
        const isLong = text.length > 100;
        const display = isLong ? text.substring(0, 100) + "…" : text;

        return (
          <span title={isLong ? text : ""}>
            {display}
          </span>
        );
      }
    },
    {
      name: 'Plates',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Assignment Date',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'End Date',
      selector: 'endDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unit',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Provider',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsReceptionProcessSpa = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOnTramit/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )

}

const showButtonsReceptionProcessEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsOnTramit/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showTrafficLightsReceptionProcessSpa = (row) => {
  switch (row.orderDays) {
    case '+15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleRedProcess}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              +15 días
            </label>
          </Grid>
        </Grid>
      )
    case '-15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleGreenProcess}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              15 días
            </label>
          </Grid>
        </Grid>
      )
    default:
      return
  }
}

const showTrafficLightsReceptionProcessEng = (row) => {
  switch (row.orderDays) {
    case '+15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleRed}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              +15 days
            </label>
          </Grid>
        </Grid>
      )
    case '-15 días':
      return (
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <div style={circleStyleGreen}></div>
          </Grid>
          <Grid item xs={8}>
            <label>
              15 days
            </label>
          </Grid>
        </Grid>
      )
    default:
      return
  }
}

const showTrafficLightsWOUrgent = (row) => {
  switch (row.urgentWO) {
    case true:
      return (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <div style={circleStyleRedProcess}></div>
          </Grid>
        </Grid>
      )
    case false:
      return (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <div style={circleStyleGreenProcess}></div>
          </Grid>
        </Grid>
      )
    default:
      return (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <div style={circleStyleGreenProcess}></div>
          </Grid>
        </Grid>
      )
  }
}

const circleStyleRedProcess = {
  padding: 5,
  display: "inline-block",
  backgroundColor: "#BF2E2E",
  borderRadius: "100%",
  width: 20,
  height: 20,
}
const circleStyleGreenProcess = {
  padding: 5,
  display: "inline-block",
  backgroundColor: "#82C341",
  borderRadius: "100%",
  width: 20,
  height: 20,
}

//*Comprobation
export const ColumnsForComprobationSpa = (
  [
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Estatus',
      selector: 'woStatus',
      sortable: true,
      width: '100px',
      cell: row => row.woStatus
    },
    {
      name: 'Marca',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Modelo',
      selector: 'modelCar',
      sortable: true,
      width: '150px',
      cell: row => row.modelCar
    },
    {
      name: 'Placas',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fecha de asignación',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Fecha de cierre',
      selector: 'endDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Flota',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unidad',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Proveedor',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForComprobationSpa(row))
    },
    {
      width: '0%',
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

export const ColumnsForComprobationEng = (
  [
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Status',
      selector: 'woStatus',
      sortable: true,
      width: '100px',
      cell: row => row.woStatus
    },
    {
      name: 'Brand',
      selector: 'make',
      sortable: true,
      width: '90px',
      cell: row => row.make
    },
    {
      name: 'Model',
      selector: 'modelCar',
      sortable: true,
      width: '150px',
      cell: row => row.modelCar
    },
    {
      name: 'Plates',
      selector: 'plate',
      sortable: true,
      width: '100px',
      cell: row => row.plate
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Assignment Date',
      selector: 'assignedSupplierDate',
      width: '200px',
      center: true,
    },
    {
      name: 'End Date',
      selector: 'endDate',
      width: '200px',
      center: true,
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Unit',
      selector: 'unitNumber',
      width: '100px',
      center: true,
      cell: row => row.unitNumber
    },
    {
      name: 'Provider',
      selector: 'supplierName',
      width: '150px',
      center: true,
      cell: row => row.supplierName
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForComprobationEng(row))
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsForComprobationSpa = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsComprobation/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showButtonsForComprobationEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsComprobation/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

//*PaymentOnDelay - Pago Pendiente
export const ColumnsForPaymentOnDelaySpa = (
  [
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Folio factura',
      selector: 'invoicenumber',
      width: '200px',
      center: true,
      cell: row => row.invoicenumber
    },
    {
      name: 'UUID',
      selector: 'uuid',
      width: '300px',
      center: true,
      cell: row => row.uuid
    },
    {
      name: 'Importe de factura',
      selector: 'totalamount',
      width: '200px',
      center: true,
      cell: row => row.totalamount
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Flota',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Fecha de asignación',
      selector: 'createdDate',
      sortable: true,
      width: '100px',
      center: true,
      cell: row => row.createdDate
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForPaymentOnDelaySpa(row))
    },
    {
      width: '0%',
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

export const ColumnsForPaymentOnDelayEng = (
  [
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Invoice number',
      selector: 'invoicenumber',
      width: '200px',
      center: true,
      cell: row => row.invoicenumber
    },
    {
      name: 'UUID',
      selector: 'uuid',
      width: '300px',
      center: true,
      cell: row => row.uuid
    },
    {
      name: 'Invoice amount',
      selector: 'totalamount',
      width: '200px',
      center: true,
      cell: row => row.totalamount
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '170px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {
      name: 'Assignment date',
      selector: 'createdDate',
      sortable: true,
      width: '100px',
      center: true,
      cell: row => row.createdDate
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForPaymentOnDelayEng(row))
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsForPaymentOnDelaySpa = (row) => { // pago pendiente
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsPaymentOnDelay/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showButtonsForPaymentOnDelayEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsPaymentOnDelay/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

//*Finalization
export const ColumnsForFinalizationSpa = (
  [
    {
      name: 'Orden de Trabajo',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Estatus',
      selector: 'invoicestatus',
      sortable: true,
      width: '100px',
      cell: row => row.invoicestatus
    },
    {
      name: 'Fecha',
      selector: 'createdDate',
      width: '100px',
      center: true,
      cell: row => row.createdDate
    },
    {
      name: 'Folio factura',
      selector: 'invoicenumber',
      width: '100px',
      center: true,
      cell: row => row.invoicenumber
    },
    {
      name: 'UUID',
      selector: 'uuid',
      width: '300px',
      center: true,
      cell: row => row.uuid
    },
    {
      name: 'Importe de factura',
      selector: 'totalamount',
      width: '200px',
      center: true,
      cell: row => row.totalamount
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '180px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Flota',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {name: 'Fecha de Pago / Rechazo',
      selector: 'fechapagorechazo',
      width: '100px',
      center: true,
      cell: row => row.fechapagorechazo
    },
    {name: 'No documento de pago',
      selector: 'numerodocumentopago',
      width: '100px',
      center: true,
      cell: row => row.numerodocumentopago
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForFinalizationSpa(row))
    },
    {
      name: "",
      width: '0px',
      omit: true,
      center: true,
      cell: row => row.branchOfficeId
    }
  ]
)

export const ColumnsForFinalizationEng = (
  [
    {
      name: 'Work Order ID ',
      selector: 'woid',
      sortable: true,
      width: '100px',
      cell: row => row.woid
    },
    {
      name: 'Status',
      selector: 'woStatus',
      sortable: true,
      width: '100px',
      cell: row => row.woStatus
    },
    {
      name: 'Date',
      selector: 'createdDate',
      width: '100px',
      center: true,
      cell: row => row.createdDate
    },
    {
      name: 'Invoice number',
      selector: 'invoicenumber',
      width: '90px',
      center: true,
      cell: row => row.invoicenumber
    },
    {
      name: 'UUID',
      selector: 'uuid',
      width: '300px',
      center: true,
      cell: row => row.uuid
    },
    {
      name: 'Invoice amount',
      selector: 'totalamount',
      width: '200px',
      center: true,
      cell: row => row.totalamount
    },
    {
      name: 'VIN',
      selector: 'vinNumber',
      width: '180px',
      sortable: true,
      cell: row => row.vinNumber
    },
    {
      name: 'Fleet',
      selector: 'fleet',
      width: '100px',
      center: true,
      cell: row => row.fleet
    },
    {name: 'Paid / Rejected date',
      selector: 'fechapagorechazo',
      width: '100px',
      center: true,
      cell: row => row.fechapagorechazo
    },
    {name: 'Document payment number',
      selector: 'numerodocumentopago',
      width: '100px',
      center: true,
      cell: row => row.numerodocumentopago
    },
    {
      name: "",
      width: '50px',
      center: true,
      cell: row => (showButtonsForFinalizationEng(row))
    },
    {
      center: true,
      omit: true,
      cell: row => row.branchOfficeId
    }
  ]
)

const showButtonsForFinalizationSpa = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsFinalization/${row.branchOfficeId}&${row.woid}`} target="_blank">Detalles</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}

const showButtonsForFinalizationEng = (row) => {
  return (
    <div>
      <Popover
        title=""
        placement="bottomRight"
        trigger="click"
        content={
          <div>
            <Link component={RouterLink} to={`/collateral/WorkOrderDetailsFinalization/${row.branchOfficeId}&${row.woid}`} target="_blank">Details</Link>
          </div>}
      >
        <IconButton>
          <MoreVert />
        </IconButton>
      </Popover>
    </div>
  )
}